








































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  Contact,
  ContactsApi,
  ContactPagedCollectionApiResponse
} from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  components: {},
  computed: mapGetters({
    api: 'contactsApi'
  })
})
export default class ContactPicker extends Vue {
  @Prop({ required: true })
  private value!: number;

  @Prop({ required: false, default: false })
  private required?: boolean;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  @Prop({ required: false, default: 'Contact' })
  private labelOverride?: string;

  private api!: ContactsApi;

  private isLoading = false;

  private autoCompleteQuery = '';
  private autoCompleteContacts!: ContactPagedCollectionApiResponse;

  private autoCompleteSelected(item: Contact) {
    if (item) {
      this.$emit('input', item.contactId);
      this.$emit('contactChanged', item);
    } else {
      this.$emit('input', null);
      this.$emit('contactChanged', {});
    }
  }

  private filterContact(item: Contact, queryText: string) {
    const searchFirstName = item.firstName ? item.firstName.toLowerCase() : '';
    const searchLastName = item.lastName ? item.lastName.toLowerCase() : '';
    return (
      searchFirstName.indexOf(queryText.toLowerCase()) > -1 ||
      searchLastName.indexOf(queryText.toLowerCase()) > -1
    );
  }

  data() {
    // this lets the undefined query! refs become reactive
    // https://class-component.vuejs.org/guide/class-component.html#data
    return {
      autoCompleteQuery: undefined,
      autoCompleteContacts: undefined,
      isLoading: false
    };
  }

  @Watch('autoCompleteQuery', { immediate: true })
  private async autoCompleteQueryChanged() {
    this.isLoading = true;
    const query = {
      propertyId: this.propertyId,
      skip: 0,
      take: 10000,
      sortColumn: 'lastName',
      sortDirection: 'ascend'
    };
    try {
      this.autoCompleteContacts = await this.api.queryContacts(query);
    } catch (error) {
      handleApiError(error);
    }
    this.isLoading = false;
  }

  @Watch('propertyId')
  private async propertyIdChanged() {
    this.autoCompleteQueryChanged();
  }

  private async mounted() {
    this.autoCompleteQueryChanged();
  }
}
